import React from 'react';
import { Box, Typography, Paper, Chip, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLanguageContext } from '../context/LanguageContext';
import { translations } from '../translations';

const SkillsSection = () => {
  const theme = useTheme();
  const { language } = useLanguageContext();
  const t = translations[language];

  return (
    <Box sx={{ py: 6 }}>
      <Typography
        variant="h3"
        component="h2"
        gutterBottom
        align="center"
        sx={{ mb: 6 }}
      >
        {t.skills.title}
      </Typography>

      <Grid container spacing={3}>
        {Object.entries(t.skills.categories).map(([key, category]) => (
          <Grid item xs={12} sm={6} md={4} key={key}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                height: '100%',
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  transform: 'translateY(-4px)',
                  transition: 'transform 0.3s ease-in-out',
                },
              }}
            >
              <Typography
                variant="h6"
                component="h3"
                gutterBottom
                color="primary"
                sx={{ mb: 2 }}
              >
                {category.title}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {category.skills.map((skill) => (
                  <Chip
                    key={skill}
                    label={skill}
                    sx={{
                      m: 0.5,
                      backgroundColor: theme.palette.primary.main + '20',
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        backgroundColor: theme.palette.primary.main + '30',
                        transform: 'rotate(5deg) scale(1.1)',
                      },
                    }}
                  />
                ))}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SkillsSection;
